import { component$ } from "@builder.io/qwik";
import type { ResourceInsert } from "../../../drizzle/schema";
import { Card, CardContent, CardDescription, CardTitle } from "./card";
import { CDNImage } from "./cdn-image";
import { Button } from "./button";
import { LuChevronRight } from "@qwikest/icons/lucide";

interface ResourceCardProps {
  resource: ResourceInsert;
  coachUsername: string;
  class?: string;
}

export const ResourceCard = component$(
  ({ resource, coachUsername, ...props }: ResourceCardProps) => {
    return (
      <a href={`/${coachUsername}/resources/${resource.id}`}>
        <Card class={props.class}>
          <CardContent class="flex h-full flex-col gap-2">
            {resource.imageSrc ? (
              <CDNImage
                src={resource.imageSrc}
                alt={resource.title}
                width={384}
                height={192}
                class="mb-4 aspect-[1/2] h-48 w-full rounded-lg object-cover"
              />
            ) : (
              <div class="mb-4 aspect-[1/2] w-full rounded-lg bg-gray-200" />
            )}
            <CardTitle>{resource.title}</CardTitle>
            <CardDescription class="grow-1">
              {resource.description}
            </CardDescription>
            <Button variant="secondary" class="mt-2">
              Read more <LuChevronRight />
            </Button>
          </CardContent>
        </Card>
      </a>
    );
  },
);
